// client/src/wave2Routes.js — routes for the wave-2 tools, kept in one file.
//
// App.js spreads these into its route tree. They are functions returning <Route>
// elements (not components), because react-router's <Routes> only accepts <Route>
// children.
import React from 'react';
import { Route } from 'react-router-dom';
import ReviewsPage from './pages/secure/ReviewsPage';
import TestimonialFormPage from './pages/TestimonialFormPage';
import TestimonialsPage from './pages/TestimonialsPage';
import OpenHousesPage from './pages/secure/OpenHousesPage';
import OpenHouseSignInPage from './pages/OpenHouseSignInPage';
import CommercialPage from './pages/secure/CommercialPage';
import VirtualStagingPage from './pages/secure/VirtualStagingPage';
import LeasingResponderPage from './pages/secure/LeasingResponderPage';

/** Under /dashboard (staff login). */
export const wave2DashboardRoutes = () => [
    <Route key="w2-reviews" path="reviews" element={<ReviewsPage />} />,
    <Route key="w2-open-houses" path="open-houses" element={<OpenHousesPage />} />,
    <Route key="w2-commercial" path="commercial-toolkit" element={<CommercialPage />} />,
    <Route key="w2-staging" path="virtual-staging" element={<VirtualStagingPage />} />,
    <Route key="w2-leasing-responder" path="pm-leasing-responder" element={<LeasingResponderPage />} />,
];

/** Under the public layout (header and footer). */
export const wave2PublicRoutes = () => [
    <Route key="w2-testimonials" path="testimonials" element={<TestimonialsPage />} />,
];

/** Stand-alone public pages reached by a token link (no header, no login). */
export const wave2StandaloneRoutes = () => [
    <Route key="w2-review" path="/review/:token" element={<TestimonialFormPage />} />,
    <Route key="w2-open-house" path="/open-house/:token" element={<OpenHouseSignInPage />} />,
];
